//https://stackoverflow.com/questions/5623838/rgb-to-hex-and-hex-to-rgb
export const rgbToHex = (r, g, b) => "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
export const hexToRgb = (hex, parser = true, alpha = 1, noAlpha = false) => {
    const test = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    const result = test ? {
        r: parseInt(test[1], 16),
        g: parseInt(test[2], 16),
        b: parseInt(test[3], 16)
    } : null;
    if (!result)
        return null;
    if (noAlpha)
        return `rgb(${result.r}, ${result.g}, ${result.b})`;
    return parser ? `rgba(${result.r}, ${result.g}, ${result.b}, ${alpha})` : result;
};
export const lighten = (col, amt) => {
    if (col[0] === "#")
        col = col.slice(1);
    const num = parseInt(col, 16);
    let r = (num >> 16) + amt;
    if (r > 255)
        r = 255;
    if (r < 0)
        r = 0;
    let b = ((num >> 8) & 0x00FF) + amt;
    if (b > 255)
        b = 255;
    if (b < 0)
        b = 0;
    let g = (num & 0x0000FF) + amt;
    if (g > 255)
        g = 255;
    if (g < 0)
        g = 0;
    return '#' + (g | (b << 8) | (r << 16)).toString(16);
};
let id = 0;
export const randomId = (prefix = 'id') => `${prefix}-${++id}`;
//# sourceMappingURL=styling.js.map